"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameNotificationsReceived = exports.GAME_NOTIFICATIONS_RECEIVED = void 0;
exports.GAME_NOTIFICATIONS_RECEIVED = 'GAME_NOTIFICATIONS_RECEIVED';
function gameNotificationsReceived(notifications, notificationsIndex, players, serverTime) {
    if (notificationsIndex === void 0) { notificationsIndex = 0; }
    return { type: exports.GAME_NOTIFICATIONS_RECEIVED, notifications: notifications, notificationsIndex: notificationsIndex, players: players, serverTime: serverTime };
}
exports.gameNotificationsReceived = gameNotificationsReceived;
